'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FormattedAmount = function render(_ref) {
  var amount = _ref.amount,
      currency = _ref.currency,
      format = _ref.format,
      separator = _ref.separator,
      NegWrap = _ref.NegWrap,
      props = _objectWithoutProperties(_ref, ['amount', 'currency', 'format', 'separator', 'NegWrap']);

  var decimalAmount = Math.abs(amount / 100);
  var formattedAmount = decimalAmount.toFixed(2);
  formattedAmount = formattedAmount.replace(/(\d)(?=(\d{3})+\.)/g, '$1 ').replace('.', separator);

  var amountAndCurrency = format.replace('%u', currency).replace('%n', formattedAmount);

  return amount >= 0 ? _react2.default.createElement(
    'span',
    props,
    amountAndCurrency
  ) : _react2.default.createElement(
    NegWrap,
    props,
    amountAndCurrency
  );
};

var DefaultNegWrap = function DefaultNegWrap(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ['children']);

  return _react2.default.createElement(
    'span',
    _extends({ style: { color: 'red' } }, props),
    '(',
    children,
    ')'
  );
};
DefaultNegWrap.propTypes = { children: _propTypes2.default.string };

FormattedAmount.propTypes = {
  amount: _propTypes2.default.number.isRequired,
  currency: _propTypes2.default.string.isRequired,
  format: _propTypes2.default.string.isRequired,
  separator: _propTypes2.default.string,
  NegWrap: _propTypes2.default.func
};

FormattedAmount.defaultProps = {
  format: '%n %u',
  separator: '.',
  NegWrap: DefaultNegWrap
};

var _default = FormattedAmount;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FormattedAmount, 'FormattedAmount', 'src/ReactFormattedAmount.js');

  __REACT_HOT_LOADER__.register(DefaultNegWrap, 'DefaultNegWrap', 'src/ReactFormattedAmount.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/ReactFormattedAmount.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-formatted-amount/lib/ReactFormattedAmount.js
// module id = 1023
// module chunks = 0